import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend } from 'chart.js';

// Register required Chart.js components
ChartJS.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

const BarChart = ({chartdata}) => {
  const data = {
    labels: chartdata.map(item=>item.branch),// Replace with your labels
    datasets: [
      {
        label: 'Expected',
        data: chartdata.map(item=>item.target), // Replace with your expected values
        backgroundColor: [
          'rgba(75, 192, 192, 0.6)', // Color for January
          'rgba(153, 102, 255, 0.6)', // Color for February
          'rgba(255, 206, 86, 0.6)', // Color for March
          'rgba(54, 162, 235, 0.6)', // Color for April
          'rgba(255, 159, 64, 0.6)', // Color for May
        ],
      },
      {
        label: 'Positive',
        data: chartdata.filter(item=>item.profit>0), // Replace with your positive values
        backgroundColor: [
          'rgba(54, 235, 162, 0.6)', // Color for January
          'rgba(192, 75, 192, 0.6)', // Color for February
          'rgba(99, 255, 132, 0.6)', // Color for March
          'rgba(255, 159, 64, 0.6)', // Color for April
          'rgba(153, 102, 255, 0.6)', // Color for May
        ],
      },
      {
        label: 'Negative',
        data: chartdata.filter(item=>item.profit<0), // Replace with your negative values
        backgroundColor: [
          'rgba(255, 99, 132, 0.6)', // Color for January
          'rgba(75, 192, 192, 0.6)', // Color for February
          'rgba(54, 162, 235, 0.6)', // Color for March
          'rgba(255, 206, 86, 0.6)', // Color for April
          'rgba(54, 162, 235, 0.6)', // Color for May
        ],
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Bar Chart with Expected, Positive & Negative Values with Unique Colors',
      },
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return value  // Customize tick labels
          },
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default BarChart;
